const { over, lensPath } = require("ramda")

export const reactLikeState = (set, selector) => {
  return (valueOrSetterFunction) => {
    const isFn = typeof valueOrSetterFunction === "function"
    return set(over(lensPath(selector), isFn ? valueOrSetterFunction : () => valueOrSetterFunction))
  }
}
